import styled from "styled-components";
import { ButtonVariant, controlSizeStyle, variantStyle } from "./Button.constants";

export const CustomButton = styled.button<{ $variant: ButtonVariant; $controlSize: "m" | "sm" | "xsm" }>`
	font-size: 12px;
	flex-shrink: 0;
	font-weight: 500;
	border: 1px solid #e8e8e8;
	border-radius: 4px;
	padding: 6px;
	z-index: 0;
	cursor: pointer;
	transition: 50ms;
	user-select: none;

	background-color: #1f1f1f;
	color: #ffffff;

	${({ $controlSize }) => controlSizeStyle[$controlSize]}

	${({ $variant }) => variantStyle[$variant]}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.5;
	}
`;

export const PaginationButton = styled(CustomButton)<{ $isActive: boolean }>`
    background-color: ${({$isActive}) => ($isActive ? "#EC672866" : "transparent")};
    color: black;

    &:hover {
        background-color: ${({$isActive}) => ($isActive ? "#EC672866" : "#EC672866")};
        border: 1px solid #EC672866;
    }

    &:not(:disabled):hover {
        border: 1px solid #EC672866;
    }
`;